<mat-sidenav-container class="h-100">
  <div class="login-outer-flex h-100">
    <div class="login-inner-flex h-100">
      <form [formGroup]="formGroup" class="mat-elevation-z6">
        <div class="login-header bg-primary login-header-flex" [class.bg-image]="true">
          <img class="login-logo" [src]="getLogo" alt="logo" />
          <div class="title login-title-flex">Create Admin Account</div>
        </div>

        <div class="p-3">
          <h3 class="mb-3">Welcome! This appears to be a new installation.</h3>
          <p class="mb-3">Please create the first administrator account to get started.</p>

          <mat-form-field class="w-100">
            <mat-label>Email (Username)</mat-label>
            <input matInput type="email" placeholder="Email" formControlName="username" />
            @if (usernameHasError) {
              <mat-error>{{ usernameError }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-100">
            <mat-label>First Name</mat-label>
            <input matInput placeholder="First Name" formControlName="firstname" />
            @if (firstnameHasError) {
              <mat-error>{{ firstnameError }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-100">
            <mat-label>Last Name</mat-label>
            <input matInput placeholder="Last Name" formControlName="lastname" />
            @if (lastnameHasError) {
              <mat-error>{{ lastnameError }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-100">
            <mat-label>Password</mat-label>
            <input matInput type="password" placeholder="Password" formControlName="password" />
            @if (passwordHasError) {
              <mat-error>{{ passwordError }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="w-100">
            <mat-label>Confirm Password</mat-label>
            <input matInput type="password" placeholder="Confirm Password" formControlName="confirmPassword" />
            @if (confirmPasswordHasError) {
              <mat-error>{{ confirmPasswordError }}</mat-error>
            }
          </mat-form-field>

          <button
            mat-raised-button
            color="primary"
            class="mat-elevation-z6 w-100 mt-3"
            type="button"
            (click)="register()"
            [disabled]="loading || formGroup.invalid"
          >
            @if (loading) {
              <mat-spinner color="accent" diameter="20"></mat-spinner>
            }
            @if (!loading) {
              <span>Create Admin Account</span>
            }
          </button>
        </div>
      </form>
    </div>
    <div class="login-footer-flex">
      <div class="p-3">
        <div class="text-center">
          {{ getClient }}
        </div>
      </div>
    </div>
  </div>
</mat-sidenav-container>
